import styled from 'styled-components/macro';
import { colorBlackTransparent50 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { fontWeightMedium, RegularTextLevel4 } from '@yme/tokens/typography';
export const MonthsCellStyled = styled(RegularTextLevel4) `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 56px;
  cursor: pointer;
  text-transform: capitalize;
  &:hover {
    background-color: ${colorBlackTransparent50};
  }
  ${({ isCurrentMonth }) => isCurrentMonth && fontWeightMedium};

  ${ADAPTIVE.maxWidth.tablet} {
    width: calc(100% / 6);
    height: 40px;
    border-radius: ${CORNER_RADIUS.m};
  }
`;
